import { observer } from 'mobx-react-lite';
import { SingleValue } from 'react-select';

import CurrentAccountStore from '../../../../pages/accounts/stores/current-account-store';
import BasePageLayout from '../../../../components/layouts/base-page-layout/base-page-layout';
import { SelectDropdown, IOption } from '../../../../components/inputs/select-dropdown/select-dropdown';

import { MainAction } from '../../types/action-types';
import { ActionFactory } from '../../action-registry/action-factory';
import TroubleshootingStore from '../../troubleshooting-page-store';

import './troubleshooting-layout.scss';

interface ITroubleshootingLayoutProps {
    selectedMainAction: MainAction;
    children: React.ReactNode;
    onMainActionChange: (action: MainAction) => void;
}

const TroubleshootingLayout: React.FC<ITroubleshootingLayoutProps> = observer(({
    selectedMainAction,
    children,
    onMainActionChange,
}) => {
    const mainActions = ActionFactory.getAllMainActions(CurrentAccountStore.isSysAdmin);
    const mainActionOptions: IOption[] = mainActions.map(action => ({
        value: action.id,
        label: action.label,
    }));

    const handleMainActionChange = (val: SingleValue<IOption>) => {
        if (val) {
            onMainActionChange(val.value as MainAction);
            TroubleshootingStore.resetShopifyResponse();
        }
    };

    return (
        <BasePageLayout title="Troubleshooting">
            <div className="troubleshooting-layout">
                <div className="troubleshooting-layout__header">
                    <div className="troubleshooting-layout__action-selector">
                        <SelectDropdown
                            value={mainActionOptions.find(opt => opt.value === selectedMainAction)}
                            options={mainActionOptions}
                            placeholder="Select action"
                            onChange={handleMainActionChange}
                        />
                    </div>
                </div>
                <div className="troubleshooting-layout__content">
                    {children}
                </div>
            </div>
        </BasePageLayout>
    );
});

export default TroubleshootingLayout;

